// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 支付页优化 */
.payment-page { min-height:100vh; background:var(--color-bg); }

.card { position:relative; overflow:hidden; }
.card h3 { margin:0 0 14px; font-size:.95rem; letter-spacing:.4px; color:var(--color-text); font-weight:700; }

/* 订单信息 */
.order-row { display:flex; align-items:center; gap:16px; }
.order-row img {
  width: 84px;
  height: 64px;
  border-radius: 16px;
  object-fit: cover;
  flex: 0 0 84px;
  filter: brightness(.95);
  transition: var(--transition-base);
  background: var(--color-surface-alt); /* 加载时的背景色 */
}

.order-row:hover img {
  transform: scale(1.05);
  filter: brightness(1.02);
}

/* 支付方式图标优化 */
.pay-option img {
  width: 28px;
  height: 28px;
  object-fit: contain;
  flex-shrink: 0;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
}
.order-info { flex:1 1; min-width:0; }
.order-info .title { font-size:1rem; font-weight:600; color:var(--color-text); margin-bottom:6px; letter-spacing:.4px; }
.order-info .sub { font-size:.65rem; color:var(--color-muted); letter-spacing:1px; text-transform:uppercase; display:inline-block; background:var(--color-surface-alt); padding:4px 8px; border-radius:20px; }
.order-amount { color:var(--color-danger); font-weight:800; font-size:1.15rem; letter-spacing:.5px; }

/* 支付方式 */
.pay-options { display:flex; gap:16px; }
.pay-option { flex:1 1; border:1px solid var(--color-border); border-radius:18px; padding:14px 16px; display:flex; align-items:center; gap:14px; cursor:pointer; transition:var(--transition-base); background:var(--color-surface-alt); position:relative; font-size:.85rem; font-weight:600; color:var(--color-text-sec); }
.pay-option::after { content:""; position:absolute; inset:0; background:linear-gradient(140deg,rgba(99,102,241,.15),rgba(99,102,241,0)); opacity:0; transition:var(--transition-base); border-radius:inherit; }
.pay-option input { accent-color:var(--color-primary); transform:scale(1.1); }
.pay-option img { width:28px; height:28px; object-fit:contain; }
.pay-option:hover { transform:translateY(-4px); box-shadow:var(--shadow-md); }
.pay-option.active { background:var(--color-surface); color:var(--color-text); border-color:var(--color-primary); box-shadow:0 4px 14px -6px rgba(99,102,241,.55); }
.pay-option.active::after { opacity:1; }

.amount-card .row { display:flex; justify-content:space-between; align-items:center; font-size:.9rem; }
.amount { color:var(--color-text); font-size:1.25rem; font-weight:800; letter-spacing:.5px; }

.payment-footer { position:sticky; bottom:0; background:rgba(255,255,255,.92); backdrop-filter:saturate(180%) blur(8px); border-top:1px solid var(--color-border); display:flex; justify-content:center; padding:14px 16px 18px; box-shadow:0 -4px 14px -4px rgba(0,0,0,.15); }
.confirm-btn { width:100%; max-width:720px; padding:16px 20px; font-size:1rem; font-weight:600; border-radius:18px; }
.confirm-btn:disabled { filter:saturate(.4) brightness(.92); cursor:not-allowed; }

.not-found { padding:40px 0; color:var(--color-text-sec); text-align:center; }

/* ==========================================================
   移动端响应式优化
   ========================================================== */

/* 大屏手机和小平板 (481px - 768px) */
@media (max-width: 768px) and (min-width: 481px) {
  .payment-page { padding-bottom: 20px; } /* 移除底部导航栏空间，支付页面不显示导航栏 */

  .card { margin: 16px 0; padding: 20px; }

  .order-row { gap: 14px; }
  .order-row img { width: 80px; height: 60px; }

  .pay-options { gap: 14px; }
  .pay-option {
    padding: 16px 18px;
    min-height: 56px;
    font-size: 0.9rem;
  }

  .payment-footer { padding: 16px 18px 20px; }
  .confirm-btn { padding: 16px 22px; font-size: 1rem; }
}

/* 小屏手机 (320px - 480px) */
@media (max-width: 480px) {
  .payment-page { padding-bottom: 20px; } /* 移除底部导航栏空间，支付页面不显示导航栏 */

  .card {
    margin: 12px 0;
    padding: 18px 16px;
    border-radius: 16px;
  }

  .card h3 {
    font-size: 1rem;
    margin-bottom: 16px;
    text-align: center;
  }

  /* 订单信息移动端优化 */
  .order-row {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }

  .order-row img {
    width: 100%;
    height: 160px;
    max-width: 240px;
    margin: 0 auto;
    border-radius: 12px;
    object-fit: cover;
    background: var(--color-surface-alt);
    flex: none; /* 重置flex属性 */
  }

  .order-info .title {
    font-size: 1.1rem;
    margin-bottom: 8px;
    text-align: center;
  }

  .order-info .sub {
    font-size: 0.7rem;
    padding: 6px 12px;
  }

  .order-amount {
    font-size: 1.3rem;
    text-align: center;
    margin-top: 8px;
  }

  /* 支付方式移动端优化 */
  .pay-options {
    flex-direction: column;
    gap: 12px;
  }

  .pay-option {
    padding: 16px 18px;
    min-height: 56px;
    font-size: 0.9rem;
    border-radius: 14px;
    justify-content: flex-start;
  }

  .pay-option img {
    width: 32px;
    height: 32px;
    object-fit: contain;
    filter: drop-shadow(0 2px 4px rgba(0,0,0,0.15));
  }

  .pay-option input {
    transform: scale(1.2);
    margin-right: 4px;
  }

  /* 金额卡片优化 */
  .amount-card {
    padding: 20px 18px;
    border-radius: 16px;
  }

  .amount-card .row {
    font-size: 1rem;
    margin-bottom: 8px;
  }

  .amount {
    font-size: 1.4rem;
    text-align: center;
    display: block;
    margin-top: 12px;
  }

  /* 支付底部栏优化 */
  .payment-footer {
    padding: 16px 14px 20px;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
  }

  .confirm-btn {
    padding: 16px 20px;
    font-size: 1.1rem;
    min-height: 52px;
    border-radius: 16px;
    font-weight: 700;
  }

  /* 预约信息卡片移动端优化 */
  .booking-info-card {
    padding: 18px 16px;
    margin-bottom: 16px;
    border-radius: 16px;
  }

  .booking-item {
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
  }

  .booking-label {
    min-width: auto;
    font-weight: 600;
    font-size: 0.8rem;
  }

  .booking-value {
    font-size: 0.9rem;
    padding-left: 0;
  }
}

/* 超小屏手机 (≤360px) */
@media (max-width: 360px) {
  .card {
    margin: 10px 0;
    padding: 16px 14px;
  }

  .card h3 { font-size: 0.95rem; }

  .order-row img {
    height: 140px;
    max-width: 200px;
  }

  .order-info .title { font-size: 1rem; }
  .order-amount { font-size: 1.2rem; }

  .pay-option {
    padding: 14px 16px;
    min-height: 52px;
    font-size: 0.85rem;
  }

  .pay-option img {
    width: 28px;
    height: 28px;
  }

  .amount { font-size: 1.3rem; }

  .payment-footer { padding: 14px 12px 18px; }
  .confirm-btn {
    padding: 14px 18px;
    font-size: 1rem;
    min-height: 48px;
  }

  .booking-info-card { padding: 16px 14px; }
}

/* 触摸设备优化 */
@media (pointer: coarse) {
  .pay-option {
    min-height: 56px;
    padding: 16px 20px;
  }

  .confirm-btn {
    min-height: 52px;
    padding: 16px 24px;
  }

  .order-row img {
    cursor: default; /* 移除图片的点击效果 */
  }
}

/* 横屏模式优化 */
@media (max-width: 768px) and (orientation: landscape) {
  .payment-page { padding-bottom: 70px; }

  .order-row {
    flex-direction: row;
    gap: 16px;
    text-align: left;
  }

  .order-row img {
    width: 120px;
    height: 80px;
    flex-shrink: 0;
  }

  .order-info .title { text-align: left; }
  .order-amount { text-align: right; }

  .payment-footer { padding: 12px 16px 16px; }
  .confirm-btn { min-height: 48px; }
}

/* 加载状态优化 */
.confirm-btn:disabled {
  position: relative;
  overflow: hidden;
}

.confirm-btn:disabled::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  margin: -10px 0 0 -10px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 预约信息卡片样式 */
.booking-info-card {
  background: var(--color-surface);
  border-radius: 20px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--color-border);
}

.booking-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.booking-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  line-height: 1.5;
}

.booking-label {
  color: var(--color-text-sec);
  font-size: 0.85rem;
  font-weight: 500;
  min-width: 80px;
  flex-shrink: 0;
}

.booking-value {
  color: var(--color-text);
  font-size: 0.85rem;
  flex: 1 1;
  word-break: break-word;
}

@media (max-width: 480px) {
  .booking-item {
    flex-direction: column;
    gap: 4px;
  }
  
  .booking-label {
    min-width: auto;
    font-weight: 600;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/PaymentPage.css"],"names":[],"mappings":"AAAA,UAAU;AACV,gBAAgB,gBAAgB,EAAE,0BAA0B,EAAE;;AAE9D,QAAQ,iBAAiB,EAAE,eAAe,EAAE;AAC5C,WAAW,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE;;AAE7G,SAAS;AACT,aAAa,YAAY,EAAE,kBAAkB,EAAE,QAAQ,EAAE;AACzD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,kCAAkC;EAClC,oCAAoC,EAAE,YAAY;AACpD;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;AACA,cAAc,QAAM,EAAE,WAAW,EAAE;AACnC,qBAAqB,cAAc,EAAE,eAAe,EAAE,uBAAuB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;AACvH,mBAAmB,gBAAgB,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,wBAAwB,EAAE,oBAAoB,EAAE,mCAAmC,EAAE,eAAe,EAAE,kBAAkB,EAAE;AAC7M,gBAAgB,yBAAyB,EAAE,eAAe,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;;AAEpG,SAAS;AACT,eAAe,YAAY,EAAE,QAAQ,EAAE;AACvC,cAAc,QAAM,EAAE,oCAAoC,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,YAAY,EAAE,kBAAkB,EAAE,QAAQ,EAAE,cAAc,EAAE,iCAAiC,EAAE,mCAAmC,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,eAAe,EAAE,2BAA2B,EAAE;AAC1T,qBAAqB,UAAU,EAAE,iBAAiB,EAAE,OAAO,EAAE,0EAA0E,EAAE,SAAS,EAAE,iCAAiC,EAAE,qBAAqB,EAAE;AAC9M,oBAAoB,iCAAiC,EAAE,oBAAoB,EAAE;AAC7E,kBAAkB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE;AAC/D,oBAAoB,0BAA0B,EAAE,2BAA2B,EAAE;AAC7E,qBAAqB,+BAA+B,EAAE,uBAAuB,EAAE,iCAAiC,EAAE,+CAA+C,EAAE;AACnK,4BAA4B,SAAS,EAAE;;AAEvC,oBAAoB,YAAY,EAAE,6BAA6B,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACtG,UAAU,uBAAuB,EAAE,iBAAiB,EAAE,eAAe,EAAE,mBAAmB,EAAE;;AAE5F,kBAAkB,eAAe,EAAE,QAAQ,EAAE,gCAAgC,EAAE,wCAAwC,EAAE,wCAAwC,EAAE,YAAY,EAAE,sBAAsB,EAAE,sBAAsB,EAAE,2CAA2C,EAAE;AAC9Q,eAAe,UAAU,EAAE,eAAe,EAAE,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE;AACpH,wBAAwB,mCAAmC,EAAE,kBAAkB,EAAE;;AAEjF,aAAa,cAAc,EAAE,2BAA2B,EAAE,iBAAiB,EAAE;;AAE7E;;+DAE+D;;AAE/D,6BAA6B;AAC7B;EACE,gBAAgB,oBAAoB,EAAE,EAAE,yBAAyB;;EAEjE,QAAQ,cAAc,EAAE,aAAa,EAAE;;EAEvC,aAAa,SAAS,EAAE;EACxB,iBAAiB,WAAW,EAAE,YAAY,EAAE;;EAE5C,eAAe,SAAS,EAAE;EAC1B;IACE,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,kBAAkB,uBAAuB,EAAE;EAC3C,eAAe,kBAAkB,EAAE,eAAe,EAAE;AACtD;;AAEA,yBAAyB;AACzB;EACE,gBAAgB,oBAAoB,EAAE,EAAE,yBAAyB;;EAEjE;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA,cAAc;EACd;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,oCAAoC;IACpC,UAAU,EAAE,aAAa;EAC3B;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA,cAAc;EACd;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,+CAA+C;EACjD;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA,WAAW;EACX;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA,YAAY;EACZ;IACE,uBAAuB;IACvB,eAAe;IACf,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,gBAAgB;EAChB;IACE,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA,WAAW,kBAAkB,EAAE;;EAE/B;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA,qBAAqB,eAAe,EAAE;EACtC,gBAAgB,iBAAiB,EAAE;;EAEnC;IACE,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,UAAU,iBAAiB,EAAE;;EAE7B,kBAAkB,uBAAuB,EAAE;EAC3C;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA,qBAAqB,kBAAkB,EAAE;AAC3C;;AAEA,WAAW;AACX;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe,EAAE,cAAc;EACjC;AACF;;AAEA,WAAW;AACX;EACE,gBAAgB,oBAAoB,EAAE;;EAEtC;IACE,mBAAmB;IACnB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,cAAc;EAChB;;EAEA,qBAAqB,gBAAgB,EAAE;EACvC,gBAAgB,iBAAiB,EAAE;;EAEnC,kBAAkB,uBAAuB,EAAE;EAC3C,eAAe,gBAAgB,EAAE;AACnC;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,aAAa;AACb;EACE,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,SAAO;EACP,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["/* 支付页优化 */\n.payment-page { min-height:100vh; background:var(--color-bg); }\n\n.card { position:relative; overflow:hidden; }\n.card h3 { margin:0 0 14px; font-size:.95rem; letter-spacing:.4px; color:var(--color-text); font-weight:700; }\n\n/* 订单信息 */\n.order-row { display:flex; align-items:center; gap:16px; }\n.order-row img {\n  width: 84px;\n  height: 64px;\n  border-radius: 16px;\n  object-fit: cover;\n  flex: 0 0 84px;\n  filter: brightness(.95);\n  transition: var(--transition-base);\n  background: var(--color-surface-alt); /* 加载时的背景色 */\n}\n\n.order-row:hover img {\n  transform: scale(1.05);\n  filter: brightness(1.02);\n}\n\n/* 支付方式图标优化 */\n.pay-option img {\n  width: 28px;\n  height: 28px;\n  object-fit: contain;\n  flex-shrink: 0;\n  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));\n}\n.order-info { flex:1; min-width:0; }\n.order-info .title { font-size:1rem; font-weight:600; color:var(--color-text); margin-bottom:6px; letter-spacing:.4px; }\n.order-info .sub { font-size:.65rem; color:var(--color-muted); letter-spacing:1px; text-transform:uppercase; display:inline-block; background:var(--color-surface-alt); padding:4px 8px; border-radius:20px; }\n.order-amount { color:var(--color-danger); font-weight:800; font-size:1.15rem; letter-spacing:.5px; }\n\n/* 支付方式 */\n.pay-options { display:flex; gap:16px; }\n.pay-option { flex:1; border:1px solid var(--color-border); border-radius:18px; padding:14px 16px; display:flex; align-items:center; gap:14px; cursor:pointer; transition:var(--transition-base); background:var(--color-surface-alt); position:relative; font-size:.85rem; font-weight:600; color:var(--color-text-sec); }\n.pay-option::after { content:\"\"; position:absolute; inset:0; background:linear-gradient(140deg,rgba(99,102,241,.15),rgba(99,102,241,0)); opacity:0; transition:var(--transition-base); border-radius:inherit; }\n.pay-option input { accent-color:var(--color-primary); transform:scale(1.1); }\n.pay-option img { width:28px; height:28px; object-fit:contain; }\n.pay-option:hover { transform:translateY(-4px); box-shadow:var(--shadow-md); }\n.pay-option.active { background:var(--color-surface); color:var(--color-text); border-color:var(--color-primary); box-shadow:0 4px 14px -6px rgba(99,102,241,.55); }\n.pay-option.active::after { opacity:1; }\n\n.amount-card .row { display:flex; justify-content:space-between; align-items:center; font-size:.9rem; }\n.amount { color:var(--color-text); font-size:1.25rem; font-weight:800; letter-spacing:.5px; }\n\n.payment-footer { position:sticky; bottom:0; background:rgba(255,255,255,.92); backdrop-filter:saturate(180%) blur(8px); border-top:1px solid var(--color-border); display:flex; justify-content:center; padding:14px 16px 18px; box-shadow:0 -4px 14px -4px rgba(0,0,0,.15); }\n.confirm-btn { width:100%; max-width:720px; padding:16px 20px; font-size:1rem; font-weight:600; border-radius:18px; }\n.confirm-btn:disabled { filter:saturate(.4) brightness(.92); cursor:not-allowed; }\n\n.not-found { padding:40px 0; color:var(--color-text-sec); text-align:center; }\n\n/* ==========================================================\n   移动端响应式优化\n   ========================================================== */\n\n/* 大屏手机和小平板 (481px - 768px) */\n@media (max-width: 768px) and (min-width: 481px) {\n  .payment-page { padding-bottom: 20px; } /* 移除底部导航栏空间，支付页面不显示导航栏 */\n\n  .card { margin: 16px 0; padding: 20px; }\n\n  .order-row { gap: 14px; }\n  .order-row img { width: 80px; height: 60px; }\n\n  .pay-options { gap: 14px; }\n  .pay-option {\n    padding: 16px 18px;\n    min-height: 56px;\n    font-size: 0.9rem;\n  }\n\n  .payment-footer { padding: 16px 18px 20px; }\n  .confirm-btn { padding: 16px 22px; font-size: 1rem; }\n}\n\n/* 小屏手机 (320px - 480px) */\n@media (max-width: 480px) {\n  .payment-page { padding-bottom: 20px; } /* 移除底部导航栏空间，支付页面不显示导航栏 */\n\n  .card {\n    margin: 12px 0;\n    padding: 18px 16px;\n    border-radius: 16px;\n  }\n\n  .card h3 {\n    font-size: 1rem;\n    margin-bottom: 16px;\n    text-align: center;\n  }\n\n  /* 订单信息移动端优化 */\n  .order-row {\n    flex-direction: column;\n    gap: 12px;\n    text-align: center;\n  }\n\n  .order-row img {\n    width: 100%;\n    height: 160px;\n    max-width: 240px;\n    margin: 0 auto;\n    border-radius: 12px;\n    object-fit: cover;\n    background: var(--color-surface-alt);\n    flex: none; /* 重置flex属性 */\n  }\n\n  .order-info .title {\n    font-size: 1.1rem;\n    margin-bottom: 8px;\n    text-align: center;\n  }\n\n  .order-info .sub {\n    font-size: 0.7rem;\n    padding: 6px 12px;\n  }\n\n  .order-amount {\n    font-size: 1.3rem;\n    text-align: center;\n    margin-top: 8px;\n  }\n\n  /* 支付方式移动端优化 */\n  .pay-options {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .pay-option {\n    padding: 16px 18px;\n    min-height: 56px;\n    font-size: 0.9rem;\n    border-radius: 14px;\n    justify-content: flex-start;\n  }\n\n  .pay-option img {\n    width: 32px;\n    height: 32px;\n    object-fit: contain;\n    filter: drop-shadow(0 2px 4px rgba(0,0,0,0.15));\n  }\n\n  .pay-option input {\n    transform: scale(1.2);\n    margin-right: 4px;\n  }\n\n  /* 金额卡片优化 */\n  .amount-card {\n    padding: 20px 18px;\n    border-radius: 16px;\n  }\n\n  .amount-card .row {\n    font-size: 1rem;\n    margin-bottom: 8px;\n  }\n\n  .amount {\n    font-size: 1.4rem;\n    text-align: center;\n    display: block;\n    margin-top: 12px;\n  }\n\n  /* 支付底部栏优化 */\n  .payment-footer {\n    padding: 16px 14px 20px;\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 100;\n  }\n\n  .confirm-btn {\n    padding: 16px 20px;\n    font-size: 1.1rem;\n    min-height: 52px;\n    border-radius: 16px;\n    font-weight: 700;\n  }\n\n  /* 预约信息卡片移动端优化 */\n  .booking-info-card {\n    padding: 18px 16px;\n    margin-bottom: 16px;\n    border-radius: 16px;\n  }\n\n  .booking-item {\n    flex-direction: column;\n    gap: 4px;\n    align-items: flex-start;\n  }\n\n  .booking-label {\n    min-width: auto;\n    font-weight: 600;\n    font-size: 0.8rem;\n  }\n\n  .booking-value {\n    font-size: 0.9rem;\n    padding-left: 0;\n  }\n}\n\n/* 超小屏手机 (≤360px) */\n@media (max-width: 360px) {\n  .card {\n    margin: 10px 0;\n    padding: 16px 14px;\n  }\n\n  .card h3 { font-size: 0.95rem; }\n\n  .order-row img {\n    height: 140px;\n    max-width: 200px;\n  }\n\n  .order-info .title { font-size: 1rem; }\n  .order-amount { font-size: 1.2rem; }\n\n  .pay-option {\n    padding: 14px 16px;\n    min-height: 52px;\n    font-size: 0.85rem;\n  }\n\n  .pay-option img {\n    width: 28px;\n    height: 28px;\n  }\n\n  .amount { font-size: 1.3rem; }\n\n  .payment-footer { padding: 14px 12px 18px; }\n  .confirm-btn {\n    padding: 14px 18px;\n    font-size: 1rem;\n    min-height: 48px;\n  }\n\n  .booking-info-card { padding: 16px 14px; }\n}\n\n/* 触摸设备优化 */\n@media (pointer: coarse) {\n  .pay-option {\n    min-height: 56px;\n    padding: 16px 20px;\n  }\n\n  .confirm-btn {\n    min-height: 52px;\n    padding: 16px 24px;\n  }\n\n  .order-row img {\n    cursor: default; /* 移除图片的点击效果 */\n  }\n}\n\n/* 横屏模式优化 */\n@media (max-width: 768px) and (orientation: landscape) {\n  .payment-page { padding-bottom: 70px; }\n\n  .order-row {\n    flex-direction: row;\n    gap: 16px;\n    text-align: left;\n  }\n\n  .order-row img {\n    width: 120px;\n    height: 80px;\n    flex-shrink: 0;\n  }\n\n  .order-info .title { text-align: left; }\n  .order-amount { text-align: right; }\n\n  .payment-footer { padding: 12px 16px 16px; }\n  .confirm-btn { min-height: 48px; }\n}\n\n/* 加载状态优化 */\n.confirm-btn:disabled {\n  position: relative;\n  overflow: hidden;\n}\n\n.confirm-btn:disabled::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 20px;\n  height: 20px;\n  margin: -10px 0 0 -10px;\n  border: 2px solid transparent;\n  border-top: 2px solid currentColor;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* 预约信息卡片样式 */\n.booking-info-card {\n  background: var(--color-surface);\n  border-radius: 20px;\n  padding: 20px;\n  margin-bottom: 20px;\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--color-border);\n}\n\n.booking-details {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.booking-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  line-height: 1.5;\n}\n\n.booking-label {\n  color: var(--color-text-sec);\n  font-size: 0.85rem;\n  font-weight: 500;\n  min-width: 80px;\n  flex-shrink: 0;\n}\n\n.booking-value {\n  color: var(--color-text);\n  font-size: 0.85rem;\n  flex: 1;\n  word-break: break-word;\n}\n\n@media (max-width: 480px) {\n  .booking-item {\n    flex-direction: column;\n    gap: 4px;\n  }\n  \n  .booking-label {\n    min-width: auto;\n    font-weight: 600;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
